export const themeOptions = [
  { value: 'is-dark', class: 'sv-is-dark', label: 'Dark Theme' },
  { value: 'is-light', class: 'sv-is-light', label: 'Light Theme' }
]
